(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("d9SaG", function(module, exports) {

$parcel$export(module.exports, "usePersistentProducts", function () { return $994622e871a4edbf$export$94080902e3119f53; });
$parcel$export(module.exports, "make", function () { return $994622e871a4edbf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $diVVk = parcelRequire("diVVk");

var $fEMeF = parcelRequire("fEMeF");

var $c6E1z = parcelRequire("c6E1z");

var $7KlbQ = parcelRequire("7KlbQ");

var $1xf0g = parcelRequire("1xf0g");

var $ENKTS = parcelRequire("ENKTS");

var $i3Bxr = parcelRequire("i3Bxr");

var $IFWJb = parcelRequire("IFWJb");

var $deuug = parcelRequire("deuug");

var $l7I7e = parcelRequire("l7I7e");

var $kEThe = parcelRequire("kEThe");

var $gFKzh = parcelRequire("gFKzh");

var $czXEM = parcelRequire("czXEM");

var $bbixw = parcelRequire("bbixw");

var $lcQc5 = parcelRequire("lcQc5");

var $hBcYV = parcelRequire("hBcYV");

var $gamGp = parcelRequire("gamGp");

var $4QdUt = parcelRequire("4QdUt");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $khAUl = parcelRequire("khAUl");

var $8E2YL = parcelRequire("8E2YL");

var $g3aLS = parcelRequire("g3aLS");

var $8bL3C = parcelRequire("8bL3C");

var $HqFR6 = parcelRequire("HqFR6");
function $994622e871a4edbf$export$94080902e3119f53(products, isFetching, reachedEnd) {
    var previousProducts = $l7I7e.use(products);
    var persistedProducts = isFetching ? previousProducts : products;
    var reachedEnd$1 = $2whNH.isSome(previousProducts) && isFetching ? true : reachedEnd;
    return [
        persistedProducts,
        reachedEnd$1
    ];
}
function $994622e871a4edbf$var$ProductsContent(Props) {
    var category = Props.category;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var layout = Props.layout;
    var shouldCenterSlidesOpt = Props.shouldCenterSlides;
    var isPaddingEnabledOpt = Props.isPaddingEnabled;
    var isZoomEnabledOpt = Props.isZoomEnabled;
    var enableSmartCardOpt = Props.enableSmartCard;
    var enableFirstCardOpt = Props.enableFirstCard;
    var enableLastCardOpt = Props.enableLastCard;
    var enableInlineMediaOpt = Props.enableInlineMedia;
    var priorityOpt = Props.priority;
    var forcedSize = Props.forcedSize;
    var forcedShape = Props.forcedShape;
    var forcedOpenLinkOpt = Props.forcedOpenLink;
    var hideRelatedProductId = Props.hideRelatedProductId;
    var shouldCenterSlides = shouldCenterSlidesOpt !== undefined ? shouldCenterSlidesOpt : false;
    var isPaddingEnabled = isPaddingEnabledOpt !== undefined ? isPaddingEnabledOpt : true;
    var isZoomEnabled = isZoomEnabledOpt !== undefined ? isZoomEnabledOpt : true;
    var enableSmartCard = enableSmartCardOpt !== undefined ? enableSmartCardOpt : false;
    var enableFirstCard = enableFirstCardOpt !== undefined ? enableFirstCardOpt : true;
    var enableLastCard = enableLastCardOpt !== undefined ? enableLastCardOpt : true;
    var enableInlineMedia = enableInlineMediaOpt !== undefined ? enableInlineMediaOpt : false;
    var priority = priorityOpt !== undefined ? priorityOpt : 0;
    var forcedOpenLink = forcedOpenLinkOpt !== undefined ? forcedOpenLinkOpt : function forcedOpenLink(param) {
        return /* ForceNoCards */ 3;
    };
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var account = match$1.transitiveAccount;
    var storeId = match$1.transitiveStoreId;
    var settings = match$1.settings;
    var configId = match$1.id;
    var match$2 = $g3aLS.use(undefined);
    var isSmallestPossibleGrid = match$2.isSmallestPossibleGrid;
    var isZoomEnabled$1 = match$2.isZoomEnabled && isZoomEnabled;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, match$1.categories);
    var match$3 = $aSJcu.use(undefined);
    var match$4 = match$3.windowSize;
    var windowHeight = match$4.height;
    var isMobile = match$3.isMobile;
    var match$5 = $IFWJb.use(undefined);
    var onMainImageRendered = match$5.onMainImageRendered;
    var match$6 = $9pMGg.use(undefined);
    var market = match$6.market;
    var isMiniPDPVisible = match$6.isMiniPDPVisible;
    var onOpenLink = match$6.onOpenLink;
    var onProductClick = match$6.onProductClick;
    var onAddToCart = match$6.onAddToCart;
    var smartnavApiHost = match$6.smartnavApiHost;
    var match$7 = $khAUl.use(/* Products */ 1, activeCategory, layout, enableSmartCard, enableFirstCard, enableLastCard, $iv6Yc._1(forcedOpenLink, category), category);
    var firstCard = match$7[0];
    var match$8 = $hBcYV.useRouter(undefined);
    var previewMode = match$8.previewMode;
    var sort = match$8.productSort;
    var route = match$8.route;
    var retargetingAlreadySent = $g85JO.useRef([]);
    var removeAllInfo;
    if (typeof route === "number") removeAllInfo = false;
    else switch(route.TAG | 0){
        case /* Home */ 0:
        case /* ListPage */ 1:
            removeAllInfo = isSmallestPossibleGrid;
            break;
        default:
            removeAllInfo = false;
    }
    var isPDP = $2whNH.isSome(match$8.anyProductId);
    var appliedFilters = $2whNH.keep(match$8.productFilters, function(param) {
        return !isPDP;
    });
    var defaultFilters = $2whNH.flatMap($1xf0g.ExternalConnection.getStoreCategoryConnection(category), function(connection) {
        return $1xf0g.ExternalConnection.getFilterBy(connection, account);
    });
    var effectiveFilters = $fEMeF.mergeOption(appliedFilters, defaultFilters);
    var isLive = previewMode === undefined || $7bjme.equal(previewMode, /* PreviewLive */ 1);
    var photoZoomed;
    photoZoomed = typeof route === "number" || route.TAG !== /* PDP */ 2 ? false : $2whNH.isSome(route._0.zoomedPhotoIndex);
    var connection = $1xf0g.ExternalConnection.getStoreCategoryConnection(category);
    var cardShape = $2whNH.getWithDefault(forcedShape, $1xf0g.CategoryCard.getCardShape(settings.productCardShape, undefined, category.card));
    var cardSize = $2whNH.getWithDefault(forcedSize, $1xf0g.CategoryCard.getCardSize(/* Md */ 4, category.card));
    var match$9 = $ENKTS.Inline.useInlineMedia(!isPDP && enableInlineMedia, category);
    var maxRequestedProductsPerPage;
    if (layout.TAG === /* SliderLayout */ 0) maxRequestedProductsPerPage = 10;
    else {
        var match$10 = layout._0;
        var maxRows = match$10.maxRows;
        maxRequestedProductsPerPage = maxRows !== undefined ? Math.imul($diVVk.Size.getColumns(match$10.columns), maxRows) : 10;
    }
    var match$11 = $c6E1z.useCategoryProducts(storeId, category.id, connection, settings.hideOutOfStock, appliedFilters, defaultFilters, maxRequestedProductsPerPage, sort, true, smartnavApiHost, market, undefined);
    var connectedCategorySyncStatus = match$11.syncStatus;
    var isFetchingConnectedProducts = match$11.isFetching;
    var error = match$11.error;
    var reachedEnd = match$11.reachedEnd;
    var numLoadedPages = match$11.numLoadedPages;
    var setNumPages = match$11.setNumPages;
    var numPages = match$11.numPages;
    var connectedProducts = match$11.products;
    var featuredProductsList = appliedFilters !== undefined ? [] : sort !== undefined && sort >= 2 ? [] : $1xf0g.getProducts(category);
    var featuredProductsCount = featuredProductsList.length;
    var match$12 = $c6E1z.useProductsById(storeId, $i7mYY.map(featuredProductsList, function(product) {
        return product.productId;
    }), settings.hideOutOfStock, true, category.id, smartnavApiHost, market, undefined);
    var isFetchingFeaturedProducts = match$12.isFetching;
    var featuredProducts = match$12.products;
    var featuredProductsCount$1 = $2whNH.mapWithDefault(featuredProducts, featuredProductsCount, function(prim) {
        return prim.length;
    });
    var hasAppliedFilters = $2whNH.isSome(appliedFilters);
    var hasNoResults = hasAppliedFilters && $2whNH.mapWithDefault(connectedProducts, 0, function(prim) {
        return prim.length;
    }) === 0 && reachedEnd;
    var match$13 = $994622e871a4edbf$export$94080902e3119f53(connectedProducts, isFetchingConnectedProducts, reachedEnd);
    var match$14 = $994622e871a4edbf$export$94080902e3119f53(featuredProducts, isFetchingFeaturedProducts, true);
    var connectedProducts$1 = $2whNH.getWithDefault(match$13[0], []);
    var featuredProducts$1 = $2whNH.getWithDefault(match$14[0], []);
    var featuredPlaceholders = isFetchingFeaturedProducts ? $i7mYY.makeBy(featuredProductsCount$1, function(i) {
        return /*#__PURE__*/ $g85JO.createElement($gamGp.make, {
            shape: cardShape,
            kind: /* Product */ 0,
            contentBoxStylableClassName: "product-card__content-box",
            titleStylableClassName: "category-card__title",
            key: String(i)
        });
    }) : [];
    var sliderRef = $g85JO.useRef(null);
    var match$15 = $g85JO.useState(function() {
        return false;
    });
    var setSliderInitialized = match$15[1];
    var handleSliderInit = $g85JO.useCallback(function(swiperController) {
        sliderRef.current = swiperController.el;
        $iv6Yc._1(setSliderInitialized, function(param) {
            return true;
        });
    }, [
        category
    ]);
    var getViewport = function getViewport(layout) {
        var match = sliderRef.current;
        if (layout.TAG === /* SliderLayout */ 0 && !(match == null)) return sliderRef;
        else return scrollableContainerRef;
    };
    var infiniteScrollPlaceholders = match$13[1] ? [] : $2whNH.mapWithDefault(connection, [], function(connection) {
        var placeholderLength = $81N94.int_min(maxRequestedProductsPerPage, $81N94.int_max(1, connection.count - Math.imul(numLoadedPages, maxRequestedProductsPerPage) | 0));
        var placeholderLength$1 = $7bjme.equal(connectedProducts$1, []) && error === undefined || placeholderLength < 1 ? placeholderLength : 1;
        return $i7mYY.makeBy(placeholderLength$1, function(i) {
            var makePlaceholder = function makePlaceholder(dataTestId, children, param) {
                var tmp = {
                    showTitle: !removeAllInfo,
                    shape: cardShape,
                    kind: /* Product */ 0,
                    contentBoxStylableClassName: "product-card__content-box",
                    titleStylableClassName: "category-card__title",
                    key: "infinite-" + String(i) + ""
                };
                if (dataTestId !== undefined) tmp.dataTestId = $loT9g.valFromOption(dataTestId);
                if (children !== undefined) tmp.children = $loT9g.valFromOption(children);
                return /*#__PURE__*/ $g85JO.createElement($gamGp.make, tmp);
            };
            if (i !== 0) return makePlaceholder("placeholder-card-testid", undefined, undefined);
            var tmp = {
                numLoadedPages: numLoadedPages,
                numPages: numPages,
                setNumPages: setNumPages,
                viewport: getViewport(layout),
                renderChildren: function renderChildren(el) {
                    return makePlaceholder("proximity-card-testid", $loT9g.some(el), undefined);
                },
                increaseOffsetForMobile: isMobile,
                key: "proximity-sensor"
            };
            if (error !== undefined) tmp.error = error;
            return /*#__PURE__*/ $g85JO.createElement($HqFR6.make, tmp);
        });
    });
    var match$16 = category.expandVariantsInProductsListing;
    var match$17 = settings.expandVariantsInProductsListing;
    var match$18 = $2whNH.map(account, function(account) {
        return account.expandVariantsInProductsListing;
    });
    var expandVariantsInProductsListing = match$16 !== undefined ? match$16 : match$17 !== undefined ? match$17 : match$18 !== undefined ? match$18 : false;
    var removeDuplicateProducts = function removeDuplicateProducts(listA, listB) {
        return $i7mYY.keepMap(listA, function(param) {
            var product = param[1];
            if ($i7mYY.some(listB, function(param) {
                return param[1].id === product.id;
            })) return;
            else return [
                undefined,
                product
            ];
        });
    };
    var products = $g85JO.useMemo(function() {
        var featuredProducts$2 = $7KlbQ.zipTaggedProducts($i7mYY.map(featuredProducts$1, function(product) {
            return $7KlbQ.keepVariants(product, function(variant) {
                return $7KlbQ.Variant.matchesFilter(variant, variant.options, effectiveFilters);
            });
        }), featuredProductsList);
        var connectedProducts$2 = $i7mYY.map($i7mYY.map(connectedProducts$1, function(product) {
            return $7KlbQ.keepVariants(product, function(variant) {
                return $7KlbQ.Variant.matchesFilter(variant, variant.options, effectiveFilters);
            });
        }), function(product) {
            return [
                undefined,
                product
            ];
        });
        var connectedProducts$3 = featuredProductsCount$1 <= 30 ? removeDuplicateProducts(connectedProducts$2, featuredProducts$2) : connectedProducts$2;
        var products = $i7mYY.concatMany([
            featuredProducts$2,
            connectedProducts$3
        ]);
        if (expandVariantsInProductsListing) return $7KlbQ.expandVariantsByOptionNames(settings.hideOutOfStock, appliedFilters, products, [
            "Color"
        ]);
        else return products;
    }, [
        $i7mYY.map(connectedProducts$1, function(product) {
            return $7KlbQ.getKey(undefined, product);
        }).join(""),
        $i7mYY.map(featuredProducts$1, function(product) {
            return $7KlbQ.getKey(undefined, product);
        }).join(""),
        $i7mYY.map(featuredProductsList, function(tag) {
            return $2whNH.getWithDefault(tag.variantId, tag.productId);
        }).join(""),
        expandVariantsInProductsListing,
        sort,
        effectiveFilters
    ]);
    var numOfProductsBeforeFiltering = products.length;
    var products$1 = hideRelatedProductId !== undefined ? $i7mYY.keep(products, function(param) {
        return param[1].id !== hideRelatedProductId;
    }) : products;
    var isConnectedAndHasProducts = $2whNH.mapWithDefault(connection, false, function(connection) {
        return connection.count > 0;
    });
    var isExpectedToRenderProducts = !hasAppliedFilters && isConnectedAndHasProducts && numOfProductsBeforeFiltering === 0;
    var rootMarginX = Math.imul(match$4.width, isMobile ? 3 : 2);
    var slidesPerView = Math.ceil($1xf0g.CardSize.getSlidesPerView(cardSize)) | 0;
    var slidesPerView$1 = priority !== 1 ? priority !== 2 ? undefined : slidesPerView : slidesPerView << 1;
    $g85JO.useEffect(function() {
        var productsNotSentYet = $i7mYY.keep($i7mYY.map(products$1, function(param) {
            return param[1];
        }), function(product) {
            return $i7mYY.some(retargetingAlreadySent.current, function(id) {
                return id === product.id;
            }) === false;
        });
        if (productsNotSentYet.length !== 0) {
            $gFKzh.trackRetargeting(account, configId, category, undefined, undefined, isMobile, undefined, retargetingAlreadySent.current.length, undefined, productsNotSentYet, undefined, "view_item_list");
            retargetingAlreadySent.current = $i7mYY.concat(retargetingAlreadySent.current, $i7mYY.map(productsNotSentYet, function(p) {
                return p.id;
            }));
        }
    }, [
        $i7mYY.joinWith(products$1, "|", function(param) {
            return $7KlbQ.getKey(undefined, param[1]);
        })
    ]);
    var cards = $g85JO.useMemo(function() {
        var cards = $i7mYY.concatMany([
            featuredPlaceholders,
            $i7mYY.mapWithIndex(products$1, function(index, param) {
                var product = param[1];
                var tag = param[0];
                var tagId = $2whNH.mapWithDefault(tag, "", function(tag) {
                    return tag.id;
                });
                var tagVariantId = $2whNH.flatMap(tag, function(tag) {
                    return tag.variantId;
                });
                var key = $7KlbQ.getKey(undefined, product) + tagId + $2whNH.getWithDefault(tagVariantId, String(index)) + category.id;
                var fallbackElement = /*#__PURE__*/ $g85JO.createElement($gamGp.make, {
                    showTitle: !removeAllInfo,
                    shape: cardShape,
                    kind: /* Product */ 0,
                    contentBoxStylableClassName: "product-card__content-box",
                    titleStylableClassName: "category-card__title",
                    key: key
                });
                if (photoZoomed) return fallbackElement;
                var tmp = {
                    shape: cardShape,
                    productCategory: category,
                    product: product,
                    onClick: onProductClick,
                    onAddToCart: onAddToCart,
                    onImageRendered: onMainImageRendered,
                    removeAllInfo: removeAllInfo,
                    onOpenLink: onOpenLink,
                    dataCount: index
                };
                if (tagVariantId !== undefined) tmp.activeVariantId = tagVariantId;
                if (isMiniPDPVisible !== undefined) tmp.isMiniPDPVisible = $loT9g.valFromOption(isMiniPDPVisible);
                return /*#__PURE__*/ $g85JO.createElement($deuug.make, {
                    trackRenderedElementsWithId: product.id,
                    thresholds: [
                        0.1
                    ],
                    rootMargin: "" + String(windowHeight) + "px " + String(rootMarginX) + "px",
                    viewport: getViewport(layout),
                    children: /*#__PURE__*/ $g85JO.createElement($kEThe.make, tmp),
                    fallbackElement: fallbackElement,
                    key: key
                });
            }),
            infiniteScrollPlaceholders
        ]);
        if (slidesPerView$1 !== undefined) return $i7mYY.slice(cards, 0, slidesPerView$1);
        else return cards;
    }, [
        numLoadedPages,
        $i7mYY.map($i7mYY.map(products$1, function(param) {
            return param[1];
        }), function(product) {
            return $7KlbQ.getKey(undefined, product);
        }).join(","),
        featuredPlaceholders.length,
        infiniteScrollPlaceholders.length,
        photoZoomed,
        cardShape,
        rootMarginX,
        windowHeight,
        onProductClick,
        onAddToCart,
        onMainImageRendered,
        slidesPerView$1,
        match$15[0],
        $i3Bxr.layoutToString(layout),
        removeAllInfo
    ]);
    var className = isFetchingConnectedProducts && $7bjme.notequal(connectedProducts$1, []) || isFetchingFeaturedProducts && $7bjme.notequal(featuredProducts$1, []) ? $ezf3v.prefix("opacity-50 pointer-events-none") : "";
    if (cards.length === 0 && isExpectedToRenderProducts) {
        var displayMessage = connectedCategorySyncStatus !== undefined && connectedCategorySyncStatus.isComplete ? "No products in the connected category." : "Hang tight, product are still being generated for this category.";
        var devMessage = "No products were rendered.";
        var storeCategoryId = $2whNH.mapWithDefault($1xf0g.ExternalConnection.getStoreCategoryConnection(category), "null", function(connection) {
            return '"' + connection.categoryId + '"';
        });
        return /*#__PURE__*/ $g85JO.createElement($bbixw.make, {
            error: $4QdUt.makeError(isLive, devMessage),
            displayMessage: displayMessage,
            extraInfo: {
                devMessage: devMessage,
                categoryId: category.id,
                configId: configId,
                storeCategoryId: storeCategoryId
            },
            reportEvery: 1000
        });
    }
    if (layout.TAG === /* SliderLayout */ 0) {
        var match$19 = layout._0;
        var tmp = {
            id: category.id,
            rows: match$19.rows,
            children: cards,
            shouldCenter: shouldCenterSlides,
            slidesPerView: match$19.slidesPerView,
            gap: match$19.gap,
            effect: match$19.effect,
            nav: match$19.nav,
            transition: match$19.transition,
            transitionSpeed: match$19.transitionSpeed,
            autoplay: match$19.autoplay,
            autoplayDelay: match$19.autoplayDelay,
            loop: match$19.loop,
            onInit: handleSliderInit,
            className: className
        };
        if (match$19.padding !== undefined) tmp.padding = match$19.padding;
        if (match$19.maxWidth !== undefined) tmp.maxWidth = match$19.maxWidth;
        if (firstCard !== undefined) tmp.firstSlide = $loT9g.valFromOption(firstCard);
        return /*#__PURE__*/ $g85JO.createElement($lcQc5.make, tmp);
    }
    var match$20 = layout._0;
    if (hasNoResults) return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "text-xl text-primary",
            isMobile ? "px-4" : "px-8"
        ]))
    }, "No results for selected filters.");
    var tmp$1 = {
        columns: isZoomEnabled$1 ? match$2.gridColumns : match$20.columns,
        children: cards,
        gap: match$20.gap,
        className: className
    };
    if (match$20.maxRows !== undefined) tmp$1.maxRows = match$20.maxRows;
    if (match$20.maxWidth !== undefined) tmp$1.maxWidth = match$20.maxWidth;
    var tmp$2 = isPaddingEnabled ? match$20.padding : 0;
    if (tmp$2 !== undefined) tmp$1.paddingOverride = tmp$2;
    if (firstCard !== undefined) tmp$1.firstChild = $loT9g.valFromOption(firstCard);
    var tmp$3 = match$7[1];
    if (tmp$3 !== undefined) tmp$1.lastChild = $loT9g.valFromOption(tmp$3);
    var tmp$4 = {
        slotAllowOverflow: match$9.slotAllowOverflow,
        children: /*#__PURE__*/ $g85JO.createElement($czXEM.make, tmp$1)
    };
    if (match$9.renderSlots !== undefined) tmp$4.renderSlots = $loT9g.valFromOption(match$9.renderSlots);
    if (match$9.slotCardWidth !== undefined) tmp$4.slotCardWidth = $loT9g.valFromOption(match$9.slotCardWidth);
    if (match$9.slotCardHeight !== undefined) tmp$4.slotCardHeight = $loT9g.valFromOption(match$9.slotCardHeight);
    if (match$9.slotCardOffset !== undefined) tmp$4.slotCardOffset = $loT9g.valFromOption(match$9.slotCardOffset);
    return /*#__PURE__*/ $g85JO.createElement($8bL3C.make, tmp$4);
}
$994622e871a4edbf$var$ProductsContent.displayName = "ProductsContent";
var $994622e871a4edbf$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($994622e871a4edbf$var$ProductsContent);
 /* make Not a pure module */ 
});
parcelRegister("ENKTS", function(module, exports) {

$parcel$export(module.exports, "Slider", function () { return $07aa54f05b8882da$export$472062a354075cee; });
$parcel$export(module.exports, "Inline", function () { return $07aa54f05b8882da$export$fbae5b5ffd8af05e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $1xf0g = parcelRequire("1xf0g");

var $i3Bxr = parcelRequire("i3Bxr");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $kYisC = parcelRequire("kYisC");

var $1z5jA = parcelRequire("1z5jA");

var $8E2YL = parcelRequire("8E2YL");
function $07aa54f05b8882da$var$PLPMedia$Slider(Props) {
    var classNameOpt = Props.className;
    var category = Props.category;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var match = $aSJcu.use(undefined);
    var match$1 = $8E2YL.use(undefined);
    var account = match$1.config.transitiveAccount;
    var columns = match.isMobile ? 4.2 : 7.2;
    var defaultLayout = {
        TAG: /* SliderLayout */ 0,
        _0: {
            slidesPerView: columns,
            gap: $i3Bxr.emptySliderPayload.gap,
            maxWidth: $i3Bxr.emptySliderPayload.maxWidth,
            padding: $i3Bxr.emptySliderPayload.padding,
            rows: $i3Bxr.emptySliderPayload.rows,
            effect: $i3Bxr.emptySliderPayload.effect,
            nav: $i3Bxr.emptySliderPayload.nav,
            transition: $i3Bxr.emptySliderPayload.transition,
            transitionSpeed: $i3Bxr.emptySliderPayload.transitionSpeed,
            autoplay: $i3Bxr.emptySliderPayload.autoplay,
            autoplayDelay: $i3Bxr.emptySliderPayload.autoplayDelay,
            loop: $i3Bxr.emptySliderPayload.loop
        }
    };
    var relatedMediaCount = $2whNH.flatMap($1xf0g.ExternalConnection.getStoreCategoryConnection(category), function(connection) {
        return connection.relatedMediaCount;
    });
    var taggedMedia = $kYisC.Slider.useSliderTaggedMedia(className, /* Square */ 1, columns, defaultLayout, category);
    var relatedMedia;
    if (account !== undefined) {
        var match$2 = account.plpRelatedMediaStyle;
        if (match$2 !== undefined && match$2.TAG === /* SliderLayout */ 0) {
            var connection = $1xf0g.ExternalConnection.getStoreCategoryConnection(category);
            var tmp = {
                at: /* PLP */ 1,
                scrollableContainerRef: scrollableContainerRef,
                source: connection !== undefined ? {
                    TAG: /* ByCategoryId */ 1,
                    _0: connection.categoryId
                } : /* NoSource */ 0,
                className: className
            };
            if (relatedMediaCount !== undefined) tmp.count = relatedMediaCount;
            relatedMedia = /*#__PURE__*/ $g85JO.createElement($1z5jA.Slider.make, tmp);
        } else relatedMedia = null;
    } else relatedMedia = null;
    return $2whNH.getWithDefault(taggedMedia, relatedMedia);
}
$07aa54f05b8882da$var$PLPMedia$Slider.displayName = "PLPMedia.Slider";
var $07aa54f05b8882da$export$472062a354075cee = {
    make: $07aa54f05b8882da$var$PLPMedia$Slider
};
function $07aa54f05b8882da$var$useInlineMedia(enabledOpt, category) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var match = $8E2YL.use(undefined);
    var account = match.config.transitiveAccount;
    var match$1 = $hBcYV.useRouter(undefined);
    var taggedMediaEnabled = enabled && $2whNH.isNone(match$1.productFilters) && $2whNH.isNone(match$1.productSort);
    var relatedMediaEnabled = taggedMediaEnabled && $2whNH.mapWithDefault(account, false, function(account) {
        var match = account.plpRelatedMediaStyle;
        if (match !== undefined && match.TAG === /* SliderLayout */ 0) return false;
        else return true;
    });
    var relatedMediaCount = $2whNH.flatMap($1xf0g.ExternalConnection.getStoreCategoryConnection(category), function(connection) {
        return connection.relatedMediaCount;
    });
    var taggedMedia = $2whNH.keep($kYisC.Inline.useInlineTaggedMedia(category), function(param) {
        return taggedMediaEnabled;
    });
    var match$2 = $1xf0g.TaggedMedia.getCardSize(category);
    var slotCardOffset = $1xf0g.TaggedMedia.getStartRowOffset(category);
    var connection = $1xf0g.ExternalConnection.getStoreCategoryConnection(category);
    var relatedMedia = $1z5jA.Inline.useInlineRelatedMedia(relatedMediaCount, /* PLP */ 1, category, relatedMediaEnabled, connection !== undefined ? {
        TAG: /* ByCategoryId */ 1,
        _0: connection.categoryId
    } : /* NoSource */ 0);
    var match$3;
    if (account !== undefined) {
        var match$4 = account.plpRelatedMediaStyle;
        if (match$4 !== undefined && match$4.TAG !== /* SliderLayout */ 0) {
            var span = match$4._0.span;
            match$3 = [
                span.width,
                span.height
            ];
        } else match$3 = [
            undefined,
            undefined
        ];
    } else match$3 = [
        undefined,
        undefined
    ];
    var relatedMediaSlotCardOffset;
    if (account !== undefined) {
        var match$5 = account.plpRelatedMediaStyle;
        relatedMediaSlotCardOffset = match$5 !== undefined && match$5.TAG !== /* SliderLayout */ 0 ? match$5._0.startRowOffset : undefined;
    } else relatedMediaSlotCardOffset = undefined;
    var renderSlots = $2whNH.orElse(taggedMedia, relatedMedia);
    var slotCardWidth = $2whNH.orElse(match$2[0], match$3[0]);
    var slotCardHeight = $2whNH.orElse(match$2[1], match$3[1]);
    var slotCardOffset$1 = $2whNH.orElse(slotCardOffset, relatedMediaSlotCardOffset);
    var slotAllowOverflow = $2whNH.isSome(taggedMedia);
    return {
        renderSlots: renderSlots,
        slotCardWidth: slotCardWidth,
        slotCardHeight: slotCardHeight,
        slotCardOffset: slotCardOffset$1,
        slotAllowOverflow: slotAllowOverflow
    };
}
var $07aa54f05b8882da$export$fbae5b5ffd8af05e = {
    useInlineMedia: $07aa54f05b8882da$var$useInlineMedia
};
 /* react Not a pure module */ 
});
parcelRegister("kYisC", function(module, exports) {

$parcel$export(module.exports, "Inline", function () { return $f447bb25450e6718$export$fbae5b5ffd8af05e; });
$parcel$export(module.exports, "Slider", function () { return $f447bb25450e6718$export$472062a354075cee; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xf0g = parcelRequire("1xf0g");

var $5ZuQ4 = parcelRequire("5ZuQ4");

var $lcQc5 = parcelRequire("lcQc5");

var $hBcYV = parcelRequire("hBcYV");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");
function $f447bb25450e6718$var$TaggedMediaContent$MediaCard(Props) {
    var shape = Props.shape;
    var fluid = Props.fluid;
    var imageFitToContainerOpt = Props.imageFitToContainer;
    var parentCategory = Props.parentCategory;
    var media = Props.media;
    var imageFitToContainer = imageFitToContainerOpt !== undefined ? imageFitToContainerOpt : false;
    $hBcYV.useRouter(undefined);
    var match = $8E2YL.use(undefined);
    var lastModifiedAt = match.config.lastModifiedAt;
    var match$1 = $9pMGg.use(undefined);
    var onProductClick = match$1.onProductClick;
    var onCategoryClick = match$1.onCategoryClick;
    var onProductClickFromOverlayClick = $g85JO.useCallback(function(param) {
        return function(param, product, variant) {
            return $iv6Yc._2(onProductClick, product, variant);
        };
    }, [
        lastModifiedAt
    ]);
    var onQuickViewClick = $g85JO.useCallback(function(parentCategory) {
        return $iv6Yc.__1(onCategoryClick);
    }, [
        lastModifiedAt
    ]);
    var onQuickViewClick$1 = $g85JO.useMemo(function() {
        var match = $2whNH.keep($1xf0g.Link.getCardLink(media), $1xf0g.Link.isNotEmpty);
        if (match !== undefined) return onQuickViewClick;
    }, [
        onQuickViewClick
    ]);
    var tmp = {
        category: media,
        parentCategory: parentCategory,
        shape: shape,
        fluid: fluid,
        showTitle: false,
        enableViewProductButton: false,
        imageFitToContainer: imageFitToContainer,
        onOverlayProductClick: onProductClickFromOverlayClick
    };
    if (onQuickViewClick$1 !== undefined) tmp.onClick = $loT9g.valFromOption(onQuickViewClick$1);
    return /*#__PURE__*/ $g85JO.createElement($5ZuQ4.make, tmp);
}
$f447bb25450e6718$var$TaggedMediaContent$MediaCard.displayName = "TaggedMediaContent.MediaCard";
var $f447bb25450e6718$export$a6543a2e3828db2c = {
    make: $f447bb25450e6718$var$TaggedMediaContent$MediaCard
};
function $f447bb25450e6718$export$e1981986fd453ab7(cardShape, parentCategory) {
    var match = $8E2YL.use(undefined);
    var lastModifiedAt = match.config.lastModifiedAt;
    var media = $g85JO.useMemo(function() {
        return $2whNH.flatMap($1xf0g.TaggedMedia.get(parentCategory), function(param) {
            return param.source._0;
        });
    }, [
        parentCategory,
        lastModifiedAt
    ]);
    var imageFitToContainer = $g85JO.useMemo(function() {
        return $2whNH.getWithDefault($2whNH.map($1xf0g.TaggedMedia.get(parentCategory), function(param) {
            return param.imageFit === /* FitContain */ 1;
        }), false);
    }, [
        parentCategory,
        lastModifiedAt
    ]);
    var renderCard = $g85JO.useCallback(function(index) {
        return function(category, fluid, shape) {
            return /*#__PURE__*/ $g85JO.createElement($f447bb25450e6718$var$TaggedMediaContent$MediaCard, {
                shape: $2whNH.getWithDefault(shape, cardShape),
                fluid: fluid,
                imageFitToContainer: imageFitToContainer,
                parentCategory: parentCategory,
                media: category,
                key: parentCategory.id + category.id
            });
        };
    }, [
        media
    ]);
    return $g85JO.useMemo(function() {
        return $2whNH.map(media, function(__x) {
            return $i7mYY.mapWithIndex(__x, renderCard);
        });
    }, [
        renderCard
    ]);
}
function $f447bb25450e6718$var$useInlineTaggedMedia(category) {
    $hBcYV.useRouter(undefined);
    var cardShape = $1xf0g.CategoryCard.getCardShape(undefined, undefined, category.card);
    var taggedMedia = $f447bb25450e6718$export$e1981986fd453ab7(cardShape, category);
    return $2whNH.keep(taggedMedia, function(param) {
        return $7bjme.equal($1xf0g.TaggedMedia.getDisplayType(category), /* InlineDisplay */ 0);
    });
}
var $f447bb25450e6718$export$fbae5b5ffd8af05e = {
    useInlineTaggedMedia: $f447bb25450e6718$var$useInlineTaggedMedia
};
function $f447bb25450e6718$var$useSliderTaggedMedia(classNameOpt, cardShape, columns, layout, category) {
    var className = classNameOpt !== undefined ? classNameOpt : "";
    $hBcYV.useRouter(undefined);
    var taggedMedia = $f447bb25450e6718$export$e1981986fd453ab7(cardShape, category);
    var gap;
    gap = layout._0.gap;
    var padding;
    padding = layout.TAG === /* SliderLayout */ 0 ? layout._0.padding : layout._0.padding;
    var maxWidth;
    maxWidth = layout.TAG === /* SliderLayout */ 0 ? layout._0.maxWidth : layout._0.maxWidth;
    var match = $1xf0g.TaggedMedia.getCardSize(category);
    var taggedMediaCardHeight = match[1];
    var taggedMediaCardWidth = match[0];
    var taggedMediaSlidesPerView = $1xf0g.TaggedMedia.getSlidesPerView(category);
    var renderSlider = function renderSlider(media) {
        var shape = taggedMediaCardWidth !== undefined && taggedMediaCardHeight !== undefined ? /* Custom */ {
            _0: taggedMediaCardWidth,
            _1: taggedMediaCardHeight
        } : cardShape;
        var tmp = {
            id: category.id,
            rows: 1,
            children: $i7mYY.map(media, function(f) {
                return $iv6Yc._2(f, false, shape);
            }),
            slidesPerView: $2whNH.getWithDefault(taggedMediaSlidesPerView, columns),
            gap: gap,
            className: className
        };
        if (padding !== undefined) tmp.padding = padding;
        if (maxWidth !== undefined) tmp.maxWidth = maxWidth;
        return /*#__PURE__*/ $g85JO.createElement($lcQc5.make, tmp);
    };
    return $2whNH.map($2whNH.keep(taggedMedia, function(param) {
        return $7bjme.equal($1xf0g.TaggedMedia.getDisplayType(category), /* SliderDisplay */ 1);
    }), renderSlider);
}
var $f447bb25450e6718$export$472062a354075cee = {
    useSliderTaggedMedia: $f447bb25450e6718$var$useSliderTaggedMedia
};
 /* react Not a pure module */ 
});


parcelRegister("l7I7e", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $f60c78dfdef922ea$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $loT9g = parcelRequire("loT9g");

var $3QSSt = parcelRequire("3QSSt");
function $f60c78dfdef922ea$export$1f96ae73734a86cc(value) {
    var previous = $3QSSt.usePreviousDistinct(value);
    if (value !== undefined) return $loT9g.some($loT9g.valFromOption(value));
    else return previous;
}
 /* Previous-Showside Not a pure module */ 
});


parcelRegister("7MOac", function(module, exports) {

$parcel$export(module.exports, "useUserSavedProducts", function () { return $5ab3ed8760c9d858$export$d8dd03ecc2dc1994; });
$parcel$export(module.exports, "make", function () { return $5ab3ed8760c9d858$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $c6E1z = parcelRequire("c6E1z");

var $7KlbQ = parcelRequire("7KlbQ");

var $loo94 = parcelRequire("loo94");

var $kEThe = parcelRequire("kEThe");

var $czXEM = parcelRequire("czXEM");

var $gCzsf = parcelRequire("gCzsf");

var $lcQc5 = parcelRequire("lcQc5");

var $hBcYV = parcelRequire("hBcYV");

var $gamGp = parcelRequire("gamGp");

var $d9SaG = parcelRequire("d9SaG");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $lihS4 = parcelRequire("lihS4");

var $8E2YL = parcelRequire("8E2YL");

var $g3aLS = parcelRequire("g3aLS");

var $6EwcS = parcelRequire("6EwcS");
function $5ab3ed8760c9d858$export$b151c6f087a76f71(requestType) {
    var hook = $6EwcS.use(undefined);
    var entries = requestType === "history" ? hook.history.value : requestType === "favorites" ? hook.favorites.value : [];
    var ids = $i7mYY.keepMap(entries, function(item) {
        if (item.TAG === /* Product */ 0) return item._0.id;
        else return item._0;
    });
    return [
        ids,
        $i7mYY.makeBy(ids.length, function(i) {})
    ];
}
function $5ab3ed8760c9d858$export$d8dd03ecc2dc1994(hideOutOfStockOpt, shouldFetchOpt, fixedOrderOpt, categoryId, requestType) {
    var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : false;
    var shouldFetch = shouldFetchOpt !== undefined ? shouldFetchOpt : true;
    var fixedOrder = fixedOrderOpt !== undefined ? fixedOrderOpt : false;
    var match = $9pMGg.use(undefined);
    var match$1 = $5ab3ed8760c9d858$export$b151c6f087a76f71(requestType);
    var match$2 = $lihS4.useCartProductIds(undefined);
    var match$3 = $8E2YL.use(undefined);
    var match$4 = requestType === "favorites" || requestType === "history" ? [
        match$1[0],
        match$1[1]
    ] : [
        match$2[0],
        match$2[1]
    ];
    var productIds = match$4[0];
    var ids = $i7mYY.zip(productIds, match$4[1]);
    var match$5 = $g85JO.useState(function() {
        return ids;
    });
    var ids$1 = fixedOrder ? match$5[0] : ids;
    var hideOutOfStock$1 = requestType === "favorites" ? false : hideOutOfStock;
    var match$6 = $c6E1z.useProductsById(match$3.config.transitiveStoreId, productIds, hideOutOfStock$1, shouldFetch, $2whNH.getWithDefault(categoryId, requestType), match.smartnavApiHost, match.market, undefined);
    var isFetching = match$6.isFetching;
    var match$7 = $d9SaG.usePersistentProducts(match$6.products, isFetching, false);
    var isFetching$1 = ids$1.length !== 0 && isFetching;
    var products = ids$1.length !== 0 ? match$7[0] : [];
    return {
        products: products,
        isFetching: isFetching$1,
        idDict: $d3YYW.fromArray(ids$1)
    };
}
function $5ab3ed8760c9d858$var$UserSavedProductsContent(Props) {
    var layout = Props.layout;
    var category = Props.category;
    var shouldCenterSlidesOpt = Props.shouldCenterSlides;
    var isPaddingEnabledOpt = Props.isPaddingEnabled;
    var fixedOrderOpt = Props.fixedOrder;
    var zoomableOpt = Props.zoomable;
    var requestType = Props.requestType;
    var shouldCenterSlides = shouldCenterSlidesOpt !== undefined ? shouldCenterSlidesOpt : false;
    var isPaddingEnabled = isPaddingEnabledOpt !== undefined ? isPaddingEnabledOpt : true;
    var fixedOrder = fixedOrderOpt !== undefined ? fixedOrderOpt : false;
    var zoomable = zoomableOpt !== undefined ? zoomableOpt : true;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $9pMGg.use(undefined);
    var onOpenLink = match$1.onOpenLink;
    var onProductClick = match$1.onProductClick;
    var onAddToCart = match$1.onAddToCart;
    var match$2 = $hBcYV.useRouter(undefined);
    var match$3 = $8E2YL.use(undefined);
    var settings = match$3.config.settings;
    var match$4 = $g3aLS.use(undefined);
    var match$5 = $lihS4.useCart(undefined);
    var isSmallestPossibleGrid = match$4.isSmallestPossibleGrid && zoomable;
    var removeAllInfo;
    var tmp = match$2.route;
    if (typeof tmp === "number") removeAllInfo = false;
    else switch(tmp.TAG | 0){
        case /* Home */ 0:
        case /* ListPage */ 1:
            removeAllInfo = isSmallestPossibleGrid;
            break;
        default:
            removeAllInfo = false;
    }
    var checkoutLink = settings.cart ? match$5.storeCheckoutLink : settings.checkoutLink;
    var match$6 = $5ab3ed8760c9d858$export$d8dd03ecc2dc1994(settings.hideOutOfStock, undefined, fixedOrder, $2whNH.map(category, function(category) {
        return category.id;
    }), requestType);
    var idDict = match$6.idDict;
    var isFetching = match$6.isFetching;
    var products = match$6.products;
    var placeholderText = requestType === "history" ? "There are no recently viewed items yet." : requestType === "favorites" ? "There are no items on your Favorites. Click the heart to add items." : "There are no items in your cart.";
    var placeholderCards = $g85JO.useMemo(function() {
        return $i7mYY.map($d3YYW.entries(idDict), function(param) {
            return /*#__PURE__*/ $g85JO.createElement($gamGp.make, {
                shape: settings.productCardShape,
                kind: /* Product */ 0,
                contentBoxStylableClassName: "product-card__content-box",
                titleStylableClassName: "category-card__title",
                key: param[0] + $2whNH.getWithDefault(param[1], "")
            });
        });
    }, [
        requestType,
        idDict
    ]);
    var enableAddToCart = requestType !== "cart";
    var lastChild = requestType === "cart" && checkoutLink !== undefined ? $loT9g.some(/*#__PURE__*/ $g85JO.createElement($loo94.make, {
        href: checkoutLink,
        title: "Checkout Now",
        linkLabel: "",
        shape: settings.productCardShape
    })) : undefined;
    var keys = $i7mYY.map($2whNH.getWithDefault(products, []), function(product) {
        return $7KlbQ.getKey(undefined, product);
    });
    var productCards = $g85JO.useMemo(function() {
        return $2whNH.map(products, function(__x) {
            return $i7mYY.mapWithIndex(__x, function(dataCount, product) {
                var activeVariantId = $2whNH.flatMap($d3YYW.get(idDict, product.id), function(a) {
                    return a;
                });
                var key = $7KlbQ.getKey(undefined, product) + $2whNH.getWithDefault(activeVariantId, "");
                var tmp = {
                    shape: settings.productCardShape,
                    product: product,
                    enableAddToCart: enableAddToCart,
                    highlightActiveVariant: false,
                    onClick: onProductClick,
                    onAddToCart: onAddToCart,
                    removeAllInfo: removeAllInfo,
                    onOpenLink: onOpenLink,
                    dataCount: dataCount,
                    key: key
                };
                if (category !== undefined) tmp.productCategory = $loT9g.valFromOption(category);
                if (activeVariantId !== undefined) tmp.activeVariantId = activeVariantId;
                return /*#__PURE__*/ $g85JO.createElement($kEThe.make, tmp);
            });
        });
    }, [
        requestType,
        keys,
        isFetching
    ]);
    var renderInLayout = $g85JO.useMemo(function() {
        return function(param) {
            if (layout.TAG === /* SliderLayout */ 0) {
                var match = layout._0;
                var tmp = {
                    id: requestType,
                    rows: match.rows,
                    children: param,
                    shouldCenter: shouldCenterSlides,
                    slidesPerView: match.slidesPerView,
                    gap: match.gap
                };
                if (match.padding !== undefined) tmp.padding = match.padding;
                if (match.maxWidth !== undefined) tmp.maxWidth = match.maxWidth;
                if (lastChild !== undefined) tmp.lastSlide = $loT9g.valFromOption(lastChild);
                return /*#__PURE__*/ $g85JO.createElement($lcQc5.make, tmp);
            }
            var match$1 = layout._0;
            var tmp$1 = {
                columns: match$1.columns,
                children: param,
                gap: match$1.gap,
                alwaysShowLastChild: true
            };
            if (match$1.maxRows !== undefined) tmp$1.maxRows = match$1.maxRows;
            if (match$1.maxWidth !== undefined) tmp$1.maxWidth = match$1.maxWidth;
            var tmp$2 = isPaddingEnabled ? match$1.padding : 0;
            if (tmp$2 !== undefined) tmp$1.paddingOverride = tmp$2;
            if (lastChild !== undefined) tmp$1.lastChild = $loT9g.valFromOption(lastChild);
            return /*#__PURE__*/ $g85JO.createElement($czXEM.make, tmp$1);
        };
    }, [
        requestType,
        isMobile,
        layout
    ]);
    var renderInTextBlock = function renderInTextBlock(string) {
        var tmp = {
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "text-lg text-primary",
                    isMobile ? "px-4" : "px-8",
                    shouldCenterSlides ? "text-center" : "text-left"
                ]))
            }, string)
        };
        var tmp$1 = requestType === "history" ? "recently-viewed-placeholder" : requestType === "favorites" ? "favorites-placeholder" : undefined;
        if (tmp$1 !== undefined) tmp.dataTestId = $loT9g.valFromOption(tmp$1);
        return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp);
    };
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "w-full",
            isFetching ? "opacity-50 pointer-events-none" : ""
        ]))
    }, productCards !== undefined ? productCards.length !== 0 ? $iv6Yc._1(renderInLayout, productCards) : renderInTextBlock(placeholderText) : isFetching ? $iv6Yc._1(renderInLayout, placeholderCards) : renderInTextBlock(placeholderText));
}
$5ab3ed8760c9d858$var$UserSavedProductsContent.displayName = "UserSavedProductsContent";
var $5ab3ed8760c9d858$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($5ab3ed8760c9d858$var$UserSavedProductsContent);
 /* make Not a pure module */ 
});

})();
//# sourceMappingURL=SectionContent.bs.ae43b669.js.map
